import { useEffect, useState } from "react";
import { BrowserControlKeys } from "./types";

interface Props {
  handleFunc: () => void;
  browserControl: BrowserControlKeys;
}

export const useBrowserControl = ({ handleFunc, browserControl }: Props) => {
  const [historyLength] = useState(window.history.length);

  //   const [control] = useState(
  //     browserControl === BrowserControlKeys.BACK ||
  //       browserControl === BrowserControlKeys.FRONT
  //       ? BrowserControlKeys.POPSTATE
  //       : browserControl
  //   );

  //   const handleKeyDown = useCallback(
  //     (e: Event) => {
  //       if (
  //         browserControl === BrowserControlKeys.BACK &&
  //         window.history.state === null
  //       ) {
  //         handleFunc();
  //         return;
  //       }
  //     },
  //     [browserControl, historyLength, handleFunc]
  //   );

  useEffect(
    () => {
      const control =
        browserControl === BrowserControlKeys.BACK ||
        browserControl === BrowserControlKeys.FRONT
          ? BrowserControlKeys.POPSTATE
          : browserControl;
      const handleKey = (e: Event) => {
        if (
          browserControl === BrowserControlKeys.BACK &&
          window.history.state === null
        ) {
          handleFunc();
        }
      };
      window.addEventListener(control, handleKey);

      // return () => {
      //   window.removeEventListener(control, handleKey);
      // };
    },
    // eslint-disable-next-line
    [browserControl, historyLength]
  );
};
